import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { FreeFocusInside } from 'react-focus-lock'
import BarryWindowContainer from 'components/Barry/BarryComponents/BarryWindowContainer'
import useStaticBarry from 'components/Barry/hooks/useBarryStaticPage'
import useBarryViewState from 'components/Barry/hooks/useBarryController '
import StaticBarryIcon from './StaticBarryIcon'

export default function StaticBarryDialog(): ReactElement {
  const { handleStaticPageDialogToggle, barryHelloMessage } = useStaticBarry()
  const { isBarryDialogOpen } = useBarryViewState()

  return (
    <Flex>
      <StaticBarryIcon
        handleToggle={handleStaticPageDialogToggle}
        barryPopupMessage={<Text variant="size12Weight400Line138">{barryHelloMessage?.cta}</Text>}
      />
      {isBarryDialogOpen && (
        <FreeFocusInside>
          <BarryWindowContainer handleBarryIconToggle={handleStaticPageDialogToggle} />
        </FreeFocusInside>
      )}
    </Flex>
  )
}
